import LegacyButton from "legacy/LegacyButton"
import { isPresent } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class ContractGroupV2PanelPage extends React.Component {
  nextButtonContent() {
    if (isPresent(this.props.nextButtonTitle)) {
      return this.props.nextButtonTitle
    } else {
      return (
        <span>
          Next
          <i className="fa-kit fa-chevron-right ml-2 text-xs" />
        </span>
      )
    }
  }

  render() {
    return (
      <div className="relative flex min-h-full flex-col">
        <div className="flex-grow">
          {this.props.saving && (
            <div className="absolute inset-0 z-10 bg-white/50" />
          )}
          {this.props.children}
        </div>
        {!this.props.hideNav && (
          <div className="flex justify-between">
            <LegacyButton
              disabled={!this.props.hasPrevious}
              onClick={this.props.goPrevious}
            >
              <i className="fa-kit fa-chevron-left mr-2 text-xs" />
              Back
            </LegacyButton>
            <LegacyButton
              disabled={!this.props.hasNext}
              onClick={this.props.goNext}
              type={this.props.nextButtonType || "blue-inverted"}
              processing={!!this.props.saving}
            >
              {this.nextButtonContent()}
            </LegacyButton>
          </div>
        )}
      </div>
    )
  }
}

ContractGroupV2PanelPage.propTypes = {
  children: PropTypes.node,
  goPrevious: PropTypes.func,
  goNext: PropTypes.func,
  hasPrevious: PropTypes.bool,
  hasNext: PropTypes.bool,
  hideNav: PropTypes.bool,
  nextButtonTitle: PropTypes.node,
  nextButtonType: PropTypes.string,
  saving: PropTypes.bool,
}

export default ContractGroupV2PanelPage
